export default "__VITE_ASSET__DFZuKXIv__"